import React from "react";
import HeroNew from "./misc/HeroNew";
import FooterComponent from "../../components/Footer";

const Homepage: React.FC = () => {
  return (
    <div className="font-abel">
      <HeroNew />
      <FooterComponent />
    </div>
  );
};

export default Homepage;
